import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/bthinking/bthinking/src/components/mdx/MDXPageLayout";
import { withPrefix } from 'gatsby';
import { Icon, colors } from "bold-ui";
import { Card } from "../../components/Card";
import { IconTitle } from "../../components/IconTitle";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "privacy-by-design",
      "style": {
        "position": "relative"
      }
    }}>{`Privacy by design`}</h1>
    <p>{`A metodologia do Privacy by Design foi criada por Ann Cavoukian (Ontário, Canadá) para engenharia de sistemas nos anos 1990. A metodologia corresponde a uma ideia de que os preceitos da privacidade possam ser incorporados desde a concepção do sistema.  Isso possibilitaria não uma adequação à proteção dos dados, mas a modulação de sistemas que, desde o começo, levassem em consideração no seu desenvolvimento as questões envolvendo a proteção dos dados.`}</p>
    <p>{`Assim, o Privacy by Design engloba 7 princípios:`}</p>
    <ol>
      <li parentName="ol">{`Proactive not Reactive; Preventative not Remedial`}</li>
    </ol>
    <p>{`Evitar que riscos se concretizem em incidentes relacionados à proteção dos dados`}</p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Privacy as the Default`}</li>
    </ol>
    <p>{`Se um indivíduo não fizer nada, a sua privacidade permanece intacta, estabelecendo os motivos de tratamentos dos dados pessoais, minimização de dados tratados e uso/retenção por período definido . `}</p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Privacy Embedded into Design`}</li>
    </ol>
    <p>{`A privacidade se torna um componente essencial da funcionalidade principal que está sendo entregue sem perder em usabilidade, por exemplo.`}</p>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Full Functionality – Positive-Sum, not Zero-Sum`}</li>
    </ol>
    <p>{`Evita falsas dicotomias, como privacidade versus funcionalidade. A privacidade não compromete a funcionalidade do sistema.`}</p>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`End-to-End Security – Lifecycle Protection`}</li>
    </ol>
    <p>{`Gerenciamento seguro em todo ciclo de vida dos dados: da coleta ao descarte.`}</p>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`Visibility and Transparency`}</li>
    </ol>
    <p>{`Todas as partes interessadas devem estar operando de acordo com as promessas e objetivos declarados, os quais estão  sujeitos à verificação.`}</p>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`Respect for User Privacy`}</li>
    </ol>
    <p>{`O usuário deve ser sempre priorizado, de forma a lhe garantir os seus direitos relacionados, nesse caso, à privacidade e proteção dos seus dados pessoais. `}</p>
    <p>{`Dessa forma, o processo do b_thinking, enquanto um processo de design thinking que auxilia os bridgers a criarem produtos incríveis de forma colaborativa, significa uma forma de integrar todas essas questões envolvendo privacidade e proteção de dados desde o começo, no decorrer de todo o processo. Isso traz benefícios como: a) criar uma cultura de proteção de dados dentro da organização; b) planejar atividades importantes, no desenvolvimento, de questões envolvendo proteção dos dados; c) evitar retrabalho, de adequação à normas, quando o produto já está 100% finalizado. `}</p>
    <p>{`Além disso, a própria Lei Geral de Proteção de Dados (LGPD), traz no seu artigo 46, § 2º: “ Os agentes de tratamento devem adotar medidas de segurança, técnicas e administrativas aptas a proteger os dados pessoais de acessos não autorizados e de situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou qualquer forma de tratamento inadequado ou ilícito. As medidas de que trata o caput deste artigo deverão ser observadas desde a fase de concepção do produto ou do serviço até a sua execução”. Ou seja, a própria lei brasileira coloca como um dever a implementação de medidas desde a concepção, conforme preceitua a metodologia do Privacy by Design.`}</p>
    <p>{`Assim, adequamos o b_thinking, com novas descrições de suas etapas, novas saídas e ferramentas a serem utilizadas durante o processo. Como novas ferramentas, propomos:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/methods/datacollection"
        }}>{`Template de levantamento de dados`}</a>{`, na Etapa de `}<a parentName="li" {...{
          "href": "/steps/3definition"
        }}>{`Definição`}</a>{`; `}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/methods/termsofuse"
        }}>{`Modelo de termos de uso`}</a>{`, na Etapa de `}<a parentName="li" {...{
          "href": "/steps/5prototype"
        }}>{`Prototipação`}</a>{`; `}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/methods/privacychecklist"
        }}>{`Checklist de validação do privacy by design`}</a>{`, na Etapa de `}<a parentName="li" {...{
          "href": "/steps/6validation"
        }}>{`Validação`}</a>{`; `}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/methods/securityrequirements"
        }}>{`Checklist de requisitos mínimos de segurança`}</a>{`, na Etapa de `}<a parentName="li" {...{
          "href": "/steps/7delimitation"
        }}>{`Delimitação`}</a>{`; `}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/methods/securitytests"
        }}>{`Testes de Segurança`}</a>{`, na Etapa de `}<a parentName="li" {...{
          "href": "/steps/8refinement"
        }}>{`Refinamento`}</a>{`.`}</li>
    </ul>
    <p>{`Buscamos a excelência dos nossos produtos e isso significa integrar uma efetiva proteção de dados.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      